import React, { useEffect } from "react";
import { decodeHashUrl } from "../shared-components/Utils/Functions";
import { useRouter } from "next/router";
import { withApollo } from "../lib/apollo3";
import { withAuth } from "../lib/auth";
import { withContext } from "../lib/context";
import { withTranslation } from "../shared-components/i18n";
import { PropertyDetails } from "../shared-components/ViewFragments/PropertyDetails/web";
import { RTBhouse } from "../shared-components/Components/RTBhouse/web";
import { withGlobalComponents } from "../shared-components/ViewFragments/GlobalComponents/web";
import { fetchSearchResults } from "src/services/search";
import { PropertyDataProvider } from "src/contexts/PropertyData/PropertyDataProvider";
import AdvertiserProvider from 'src/contexts/AdvertiserContext';
import Ad from 'src/hooks/ads/Ad';
import { ADS_NAME } from 'src/constants/ads';

const projectSingle = ({ __PROJECT__ID__, data, technicalSheet }) => {
	const router = useRouter();
	const { asPath } = router;
	const isPrint = asPath.includes("imprimir");

	return (
		<PropertyDataProvider initialListing={data}>
			<AdvertiserProvider>
				<PropertyDetails
					id={__PROJECT__ID__}
					mode="project"
					data={data}
					technicalSheet={technicalSheet}
				/>
				<RTBhouse page={"offer"} data={__PROJECT__ID__} />
			</AdvertiserProvider>
		</PropertyDataProvider>
	);
};

projectSingle.getInitialProps = async function ({ apolloClient, req, res, query }) {
	let project = await decodeHashUrl(query.hashed);
	const __PROJECT__ID__ = project.id;

	const payload = {
		rows: 1,
		params: {
			id: __PROJECT__ID__,
		},
		page: 1,
		source: 10,
	};

	const fetchResult = await fetchSearchResults(payload);
	const data = fetchResult.searchFast.data[0];
	let technicalSheet = null;

	if (!data) {
		// Si data es undefined, redirige a 404
		if (res) {
			res.statusCode = 404;
		} else {
			throw new Error("Data not found");
		}
	} else {
		if (project.configs.country_code === "ce3") {
			const technicalSheetCeee = [...data.technicalSheet];
			const minimumStay =
				data.seasons && !!data.seasons.length
					? `${data.seasons[0].rental_data.minimum_stay} ${data.seasons[0].rental_data.minimum_stay !== 1 ? "días" : "día"
					}`
					: null;

			technicalSheetCeee.push(
				{
					field: "guests",
					text: "Huéspedes",
					value: data.guests ? data.guests.toString() : null,
				},
				{
					field: "seaview",
					text: "Vista al mar",
					value: data.seaview ? "Sí" : "No",
				},
				{
					field: "minimum_stay",
					text: "Estadía mínima",
					value: minimumStay,
				}
			);

			const filtered = technicalSheetCeee.filter(
				(technical) => technical.field !== "disposition_name"
			);

			technicalSheet = filtered;
		} else {
			technicalSheet = data.technicalSheet;
		}
	}

	return {
		__PROJECT__ID__,
		UrlToBack: query.location || -1,
		DummyContextInitialState: { count: 23 },
		ConfigContextInitialState: project?.configs,
		data,
		technicalSheet,
	};
};


export default withApollo(
	withContext(withTranslation(withAuth(withGlobalComponents(projectSingle))), {
		withDummyContext: false,
		withFiltersContext: true,
		withConfigContext: true,
		withThemeContext: true,
	})
);
